<div class="card">
    <app-header titulo="Painel Transferência de Insumos" descricao="Transferência de insumos entre OS e baixas do estoque no SAP." />

    <div class="mt-3">
        <!-- <p-splitButton  label="Gerar Relatório" [model]="itemsMenu" icon="pi pi-list"></p-splitButton > -->
        <p-tabView>
            <p-tabPanel header="Ordens" *appHasPermission="'ACTION_PI_VISUALIZAR_ORDENS'">
                <p-button label="Atualizar Ordens" (click)="atualizarOrdens()" [loading]="loading" icon="pi pi-refresh"></p-button>

                <p-table #dtOrdens [globalFilterFields]="['noOs','dtEmissaoOs','cdUpnivel1','instancia','reservas']" [value]="ordens" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines mt-3" [resizableColumns]="true" [breakpoint]="'960px'" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true" scrollHeight="400px">
                    <ng-template pTemplate="caption">
                        <div class="flex">
                            <span class="p-input-icon-left ml-auto">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" (input)="dtOrdens.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>OS</th>
                            <th>Data Emissão</th>
                            <th>Instância</th>
                            <th>Fazenda</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-ordem>
                        <tr>
                            <td>{{ ordem.noOs }}</td>
                            <td>{{ ordem.dtEmissaoOs | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ ordem.instancia }}</td>
                            <td>{{ ordem.cdUpnivel1 }} - {{ordem.deUpnivel1}}</td>
                            <td>{{ statusOrdem(ordem.fgSituacao) }}</td>
                            <td><a [routerLink]="['/painelinsumos','detalhes', ordem.id]"><p-button icon="pi pi-search" severity="primary" class="m-1" aria-label="Acessar"></p-button></a></td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>

            <p-tabPanel header="Relatórios" *appHasPermission="'ACTION_PI_RELATORIO'">
                <painelinsumo-relatorios></painelinsumo-relatorios>
            </p-tabPanel>
        </p-tabView>


    </div>
</div>
